import PropTypes from 'prop-types'

import { AxleLoadEvent } from '../../models/ebs/axle-load-event-enum'
import { iso8601PropType } from '../common/iso-8601-prop-type'

const { AXLE_LOAD, SPEED, TIMESTAMP } = AxleLoadEvent

/**
 * @typedef {Object} AxleLoadEvent
 *
 * @property {number} axleLoad      - The axle load of the axle load event
 * @property {number} [speed]       - The speed of the axle load event
 * @property {ISO8601} timestamp    - The registration time of the axle load event
 */
export const axleLoadEventPropType = PropTypes.shape({
    [AXLE_LOAD]: PropTypes.number.isRequired,
    [SPEED]: PropTypes.number,
    [TIMESTAMP]: iso8601PropType.isRequired
})
